export const STATUS = [
  { label: '待接班', value: '0', color: '#165dff' },
  { label: '已接班', value: '1', color: '#52c41a' },
  { label: '已完成', value: '2', color: '#52c41a' },
  { label: '待初审', value: '3', color: '#ff9900' },
  { label: '待复审', value: '4', color: '#4bd0de' },
  { label: '已复审', value: '5', color: '#915be1' },
];

// 根据状态值获取标签
export const getStatusLabel = (value: string | null): string => {
  const status = STATUS.find(s => s.value === value);
  return status?.label || '待接班';
};

// 根据状态值获取颜色
export const getStatusColor = (value: string | null): string => {
  const status = STATUS.find(s => s.value === value);
  return status?.color || '#165dff';
};
